import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const postReference = async (spaceUuid, { params, body }) => {
    const { data } = await axios.post(apiSpaceUrl("reference", spaceUuid), body, {
        params: params,
    });
    return data;
};

export const postReferenceAddFromSource = async (spaceUuid, { body }) => {
    const { data } = await axios.post(apiSpaceUrl("referenceAddFromSource", spaceUuid), body);
    return data;
};

export const postBulkReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("reference", spaceUuid) + "/bulk-create", body);
    return data;
};

export const patchReference = async (spaceUuid, body) => {
    let headers = {};
    if (body.file) {
        headers = {
            "Content-Type": "multipart/form-data",
        };
    }
    const { data } = await axios.patch(apiSpaceUrl("reference", spaceUuid) + "/" + body.id, body, {
        headers: headers,
    });
    return data;
};

export const putBibJson = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("reference", spaceUuid) + "/" + body.id + "/bib-json", body);
    return data;
};

export const getReferences = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("reference", spaceUuid), { params: params });
    return data;
};

export const getReference = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("reference", spaceUuid) + "/no/" + params.reference_no);
    return data;
};

export const deleteReference = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("reference", spaceUuid) + "/bulk_delete", {
        data: body,
    });

    return data;
};

export const deleteReferencePdfFile = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("reference", spaceUuid) + "/file/reference", {
        data: body,
    });

    return data;
};

export const getJsonToBib = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("reference", spaceUuid) + "/json-to-bib", body);
    return data;
};

export const restartReferenceFileIndexing = async (spaceUuid, reference_file_id) => {
    const { data } = axios.put(apiSpaceUrl("referenceFile", spaceUuid) + "/indexing-restart", {
        reference_file_id,
    });

    return data;
};

export const getTags = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("tag", spaceUuid), { params: params });

    data.sort((a, b) => {
        if (a.name < b.name) return -1;
        else return 1;
    });
    return data;
};

export const postTag = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid), body);
    return data;
};

export const putTag = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("tag", spaceUuid) + `/${body.id}`, body);
    return data;
};

export const deleteTag = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("tag", spaceUuid) + `/${body.id}`);
    return data;
};

export const deleteBulkTag = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("tag", spaceUuid) + `/bulk-delete`, { data: body });
    return data;
};

export const addTagReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/reference`, body);
    return data;
};

export const changeTagOrder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/order`, body);
    return data;
};

export const getTagRecommendation = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("tag", spaceUuid) + `/recommend`, body);
    return data;
};

export const getFolders = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("folder", spaceUuid), { params: params });
    return data;
};

export const postFolder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid), body);
    return data;
};

export const putFolder = async (spaceUuid, body) => {
    const { data } = await axios.put(apiSpaceUrl("folder", spaceUuid) + `/${body.id}`, body);
    return data;
};

export const deleteBulkFolder = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("folder", spaceUuid) + `/bulk-delete`, { data: body });
    return data;
};

export const addFolderReference = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid) + `/reference`, body);
    return data;
};

export const changeFolderOrder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid) + `/order`, body);
    return data;
};

export const mergeFolder = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("folder", spaceUuid) + `/merge`, body);
    return data;
};

export const getReferenceFilePdf = async (fileUrl) => {
    const apiOrigin = window.location.protocol + "//" + process.env.REACT_APP_API_BASE_URL;
    const resolvedFileUrl = new URL(fileUrl, apiOrigin).href;
    // aws s3 파일 접근 시 전역 auth 헤더가 들어가면 접근이 안되서 직접 fetch 사용
    const response = await fetch(resolvedFileUrl);
    if (!response.ok) {
        throw new Error(`PDF file download failed: ${response.status}`);
    }
    return response.arrayBuffer();
};

export const getReferenceReviewPageLayout = async (spaceUuid, { reference_file_uuid, page }) => {
    const { data } = await axios.get(apiSpaceUrl("referenceReview", spaceUuid) + `/${reference_file_uuid}/layout`, {
        params: { page },
    });
    return data;
};
